import template from './mini-cart-line.html';

export const listItem = (name, value) => {
    const title = name ? `
        <span class="mini-cart-line__title">
            ${name}
        </span>
    `: '';

    return `
        <li class="mini-cart-line__item">
            ${title}
            <span class="mini-cart-line__desc">
                ${value}
            </span>
        </li>
    `;
};

export default template;
